import React from 'react';
import classes from './clearButton.module.scss';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';

interface Props {
    onClear: () => void;
    disabled?: boolean;
}

export const ClearButton = ({ onClear, disabled }: Props) => {
    return (
        <div className={`${classes.wrapper}`} key="clear-btn">
            <div
                className={`rdw-option-wrapper ${classes.clearButton} ${disabled ? classes.disabled : ''}`}
                title="Clear text"
                onClick={() => {
                    if (!disabled) onClear();
                }}
            >
                <MuiIcon icon={'clear'} fontSize={'2.7rem'} color={'black'} />
            </div>
        </div>
    );
};
